
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class RegexPatterns {
	static isMobileNumber: RegexPatternsType = '^(2|30|31|40|41|42|50|51|52|53|60|61|71|81|91|92|93)';

	static values = ['^(2|30|31|40|41|42|50|51|52|53|60|61|71|81|91|92|93)'];
}
export type RegexPatternsType = '^(2|30|31|40|41|42|50|51|52|53|60|61|71|81|91|92|93)';

